import { Injectable } from '@angular/core';
import notify from 'devextreme/ui/notify';
import moment from 'moment';
import pdfMake from 'pdfmake/build/pdfmake';
import pdfFonts from 'pdfmake/build/vfs_fonts';
import { DokumentiService } from '../pages/dokumenti/dokumenti.service';
import { AuthService } from '../shared/services';

pdfMake.vfs = pdfFonts.pdfMake.vfs;

@Injectable({
  providedIn: 'root',
})
export class PdfZaOtpremniceService {
  constructor(private service: DokumentiService, private authService: AuthService) {}

  //IZRDA PDF-a OTPREMNICE
  pdfOtpremnica(data) {
    //console.log('DATA: ', data);

    let hLine = {
      table: {
        widths: ['*'],
        body: [[''], ['']],
      },
      layout: {
        hLineWidth: function (i, node) {
          return i === 0 || i === node.table.body.length ? 0 : 1;
        },
        vLineWidth: function (i, node) {
          return 0;
        },
      },
    };

    this.service.dohvatiJednuOtpremnicu({ pz_id: data.data.pz_id }).subscribe((res) => {
      //console.log('res: ', res);
      if (res.success == true) {

        let ct = [];

        ct.push({
          columns: [
            {
              table: {
                widths: [200],
                heights: [95],
                body: [
                  [
                    {
                      table: {
                        body: [
                          [
                            {
                              text: `Isporuka: ${data.data.pa_naziv}`,
                              style: 'subtitle',
                            },
                          ],
                          [
                            {
                              text: `OIB: ${data.data.pa_oib || ''}`,
                              style: 'subtitle',
                            },
                          ],
                          [
                            {
                              text: ` 
                                Poslovnica kupca: 
                                ${data.data.pp_naziv}
                                ${data.data.pp_adresa}
                                ${data.data.pp_posta || ''}` + ' ' + `${data.data.pp_mjesto || ''}`,
                              style: 'subtitle',
                              bold: true,
                            }
                          ]
                        ],
                      },
                      layout: 'noBorders',
                    },
                  ],
                ],
              },
            },

            {
              table: {
                widths: [250],
                heights: [95],
                body: [
                  [
                    {
                      table: {
                        body: [
                          [
                            {
                              text: 'PEKAR d.o.o.',
                              style: 'title',
                            },
                          ],
                          [
                            {
                              text: 'Obrtnička 5',
                              style: 'subtitle',
                            },
                          ],
                          [
                            {
                              text: 'Vinkovci',
                              style: 'subtitle',
                            },
                          ],
                          [
                            {
                              text: 'Društvo upisano kod Trgovačkog suda u Osijeku MBS: 030084282, OIB: 67289965400. Temeljni kapital 5.384.400,00 kn; Predsjednik uprave: Bosiljko Stanić, direktor. Ž.r. Raiffeisen Bank 2484008-1106129914   IBAN: HR4024840081106129914 Ž.r. Otp bank 2407000-1100629330 IBAN: HR4024070001100629330 SWIFT: OTPVHR2X',
                              style: 'details',
                            },
                          ],
                        ],
                      },
                      layout: 'noBorders',
                    },
                  ],
                ],
              },
            },
          ],
        });

        ct.push({
          text: '\n' + '\n',
        });

        ct.push({
          columns: [
            {
              
            },

            {
              text:
                `Datum otpremnice: ${moment(data.data.pz_datum).format('DD.MM.YYYY')}.
                Kreirao: ${data.data.name || ''},
                Datum kreiranja: ${moment(data.data.pz_danisat).format('DD.MM.YYYY. HH:mm:ss')}
                Broj narudžbe: ${data.data.pz_napomena || ''}`,
              style: 'subtitle',
            },
          ],
        });

        ct.push({
          text: '\n' + '\n',
        });

        //SREDINA OTPREMNICA I BROJ OTPREMNICE
        ct.push({
          text:
            'Otpremnica: ' +
            data.data.po_sifra +
            '-' +
            data.data.pz_broj +
            '/' +
            moment(data.data.pz_datum).format('YYYY'),
          style: 'mainTitle',
          alignment: 'center',
          margin: [0, 0, 0, 0],
        });

        //GLAVNA TABLICA I PODACI
        let brojac = 1;
        let ukupnoKolicina = 0;
        let ukupnoTezina = 0;
        let ukupnoBrojKartona = 0;
        let ukupnoBrojPaleta = 0;
        let nema_lot = 1;

        let arr = res.prometstavke;
        //bilo prije pa artikli koji nemaju lot budu grupirani pod null i onda nije valjao ispis
        /*
        let result = arr.reduce(function (r, a) {
          r[a.ar_lot] = r[a.ar_lot] || [];
          r[a.ar_lot].push(a);
          return r;
        }, Object.create(null));
        */
        let result = arr.reduce(function(r, a) {
          const key = a.ar_lot === null ? 'nema_lot_' + nema_lot++ : a.ar_lot;
          r[key] = r[key] || [];
          r[key].push(a);
          return r;
        }, Object.create(null));
        //console.log(result);

        ct.push(hLine);
        ct.push({
          table: {
            //Rbr. Šifra EAN kod Naziv artikla Jed. mjere Količina Neto težina Broj kartona Broj paleta
            widths: [15, 30, 55, 140, 25, 35, 35, 30, 22, 23],
            body: [
              [
                'Rb',
                'Šifra' + '\n' + 'LOT',
                'EAN kod' + '\n' + 'Rok trajanja',
                'Naziv artikla',
                'Jed. mjere',
                'Količina',
                'Neto težina (kg)',
                'Broj kartona',
                'Broj paleta',
                'Još izdano',
              ],
            ],
          },
          layout: 'lightHorizontalLines',
        });

        ct.push(hLine);
        for (let lot in result) {
          let stavkaSifra = '';
          let stavkaEanKod = '';
          let stavkaNaziv = '';
          let stavkaJedMjere = '';
          let stavkaKolicina = 0;
          let stavkaNetoTezina = 0;
          let stavkaBrojKartona = 0;
          let stavkaBrojPaleta = 0;

          //console.log('RESULT ', result);
          //console.log('LOT: ', lot);


          for (let stavka of result[lot]) {
            //console.log('STAVKA: ', stavka);
            //console.log('result[lot]: ', result[lot]);

            stavkaSifra = stavka.ar_sifra + '\n' + `${stavka.ar_lot || '/'}`;
            //bilo, 26.09.2025. izmjenjeno na zahtjev Martine
            //stavkaEanKod = `${stavka.bk_kod || '/'}` + '\n' + moment(stavka.pz_datum).add(stavka.ar_roktrajanja, 'd').format('DD.MM.YYYY');
            stavkaEanKod = (stavka.bk_kod + '\n' + ((stavka.ps_vazido != null ? moment(stavka.ps_vazido).format('DD.MM.YYYY') : (stavka.vazi_do_rnalog != null ? moment(stavka.vazi_do_rnalog).format('DD.MM.YYYY') : '/'))));
            stavkaNaziv = stavka.ar_naziv;
            stavkaJedMjere = stavka.jedinicamjere_JM_SIFRA;
            stavkaKolicina = stavka.ps_izlaz;
            stavkaNetoTezina = stavka.ar_tezina;
            stavkaBrojKartona = (stavka.ps_izlaz != 0 && stavka.bk_ukarton != 0) ? (stavka.ps_izlaz / stavka.bk_ukarton) : 0;
            stavkaBrojPaleta = (stavka.ps_izlaz != 0 && stavka.bk_ukarton != 0 && stavka.bk_kartonpaleta != 0) ? stavka.ps_izlaz / (stavka.bk_ukarton * stavka.bk_kartonpaleta) : 0;

            ukupnoKolicina += stavka.ps_izlaz;
            ukupnoTezina += stavka.ar_tezina;
            ukupnoBrojKartona += stavkaBrojKartona;
            ukupnoBrojPaleta += stavkaBrojPaleta;
          }

          ct.push({
            table: {
              //Rbr. Šifra EAN kod Naziv artikla Jed. mjere Količina Neto težina Broj kartona Broj paleta
              widths: [15, 30, 55, 140, 25, 35, 35, 30, 22, 23],
              body: [
                [
                  brojac++,
                  stavkaSifra,
                  stavkaEanKod,
                  stavkaNaziv,
                  stavkaJedMjere,
                  { text: this.formatiraj(stavkaKolicina, 2), alignment: 'right' },
                  { text: this.formatiraj(stavkaNetoTezina, 2), alignment: 'right' },
                  { text: this.formatiraj(stavkaBrojKartona, 2), alignment: 'right' },
                  { text: this.formatiraj(stavkaBrojPaleta, 2), alignment: 'right' },
                ],
              ],
            },
            layout: 'lightHorizontalLines',
          });
        }

        //UKUPNO
        ct.push(hLine);
        ct.push({
          table: {
            widths: [332, 40, 42, 38, 30],
            body: [
              [
                {
                  text: 'UKUPNO',
                  style: 'tableFooter',
                  margin: [5, 0, 0, 0],
                },
                { text: this.konvertiraj(ukupnoKolicina), alignment: 'right', style: 'tableFooter' },
                { text: this.konvertiraj(ukupnoTezina), alignment: 'right', style: 'tableFooter' },
                { text: this.konvertiraj(ukupnoBrojKartona), alignment: 'right', style: 'tableFooter' },
                { text: this.konvertiraj(ukupnoBrojPaleta), alignment: 'right', style: 'tableFooter' },
              ],
            ],
          },
          layout: 'noBorders',
        });

        //POTPISI
        let signatureLine = {
          table: {
            widths: ['100%'],
            body: [[''], ['']],
          },
          layout: {
            hLineWidth: function (i, node) {
              return i === 0 || i === node.table.body.length ? 0 : 1;
            },
            vLineWidth: function (i, node) {
              return 0;
            },
          },
        };

        ct.push({
          columns: [
            [
              {
                text: 'Robu otpremio:',
                margin: [0, 60, 0, 30],
                aligment: 'center',
              },
              signatureLine,
            ],
            [],
            [],
            [
              {
                text: 'Robu primio:',
                margin: [0, 60, 0, 30],
                aligment: 'center',
              },
              signatureLine,
            ],
          ],
        });

        var dd = {
          info: {
            title: 'Otpremnica: ' + data.data.pz_id,
          },
          content: ct,
          pageMargins: 20,
          defaultStyle: {
            fontSize: 7.5,
          },
          styles: {
            title: {
              fontSize: 12,
              bold: true,
            },
            subtitle: {
              fontSize: 10,
            },
            details: {
              fontSize: 6,
            },
            tableTitle: {
              fontSize: 8,
              bold: true,
            },
            mainTitle: {
              fontSize: 17,
              bold: true,
            },
            tableFooter: {
              bold: true,
            },
          },
        };

        //PODACI NAKON POTPISA
        ct.push({
          columns: [
            {
              table: {
                widths: [500],
                body: [
                  [
                    {
                      text: 'Prijevozni agent: ' + `${data.data.prijevoznik || ''}`,
                      bold: true,
                    },
                  ],

                  //PRAZAN RED
                  [''],
                  [''],
                  [''],
                  [''],
                  [''],
                  [''],
                  [''],
                  [''],

                  [
                    {
                      text: 'Broj kartona: ' + this.konvertiraj(ukupnoBrojKartona),
                      bold: true,
                    },
                  ],
                  [
                    {
                      text: 'Bruto težina: ' + this.konvertiraj(ukupnoTezina) + ' kg',
                      bold: true,
                    },
                  ],

                  //PRAZAN RED
                  [''],
                  [''],
                  [''],
                  [''],

                  [
                    {
                      text: 'Ukupno paleta: ' + this.konvertiraj(ukupnoBrojPaleta),
                      bold: true,
                    },
                  ],

                  //PRAZAN RED
                  [''],
                  [''],

                  [
                    {
                      text: 'Vrsta transporta: ' + `${data.data.pz_napomena || ''}`,
                    },
                  ],
                  [
                    {
                      text: 'Paritet:',
                    },
                  ],
                ],
              },
              layout: 'noBorders',
            },
          ],
        });

        pdfMake.createPdf(dd).open();
      } else {
        notify('Došlo je do pogreške pri dohvaćanju podataka. Pokušajte ponovo.', 'warning', 3000);
      }
    });
  }

  konvertiraj(a: any) {
    return this.authService.konvertirajCijenu().konvertiraj(a);
  }

  formatiraj(broj: any, dec_mj: any){
    return this.authService.formatiraj(broj, dec_mj);
  }

}
